import { AdminRole } from '../type/AdminRole'
import { Permission } from '../../../types/permission'

const PATIENT_ADMIN_PERMISSIONS = [
  Permission.ORGANIZATION_MANAGEMENT,
  Permission.PATIENT_MANAGEMENT,
]
const RX_ADMIN_PERMISSIONS = [...PATIENT_ADMIN_PERMISSIONS, Permission.PRESCRIPTION_MANAGEMENT]
const SUPER_ADMIN_PERMISSIONS = [
  ...RX_ADMIN_PERMISSIONS,
  Permission.USER_MANAGEMENT,
  Permission.BILLING_MANAGEMENT,
  Permission.LOCATION_MANAGEMENT,
  Permission.DATA_EXPORT_MANAGEMENT,
]

const adminRolePermissionMapping = {
  ['patient_admin']: PATIENT_ADMIN_PERMISSIONS,
  ['rx_admin']: RX_ADMIN_PERMISSIONS,
  ['super_admin']: SUPER_ADMIN_PERMISSIONS,
}

export const convertRoleToPermissions = (role: AdminRole): Permission[] => {
  if (!role) {
    return []
  }
  return adminRolePermissionMapping?.[role] ?? []
}
